import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { ApolloLink } from 'apollo-link';
import { RetryLink } from 'apollo-link-retry';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloProvider } from '@apollo/react-hooks';

var httpLink = createHttpLink({
  uri: '/api/2019-07/graphql.json'
});

var middlewareLink = setContext(function () {
  return {
    headers: {
      'X-Shopify-Storefront-Access-Token': 'bef77248a7f2c65f44b1889bf9c3a291'
    }
  };
});

var retryLink = new RetryLink();

var cache = new InMemoryCache();

var client = new ApolloClient({
  link: ApolloLink.from([middlewareLink, retryLink, httpLink]),
  cache: cache,
  fetchOptions: {
    mode: 'no-cors'
  }
});

ReactDOM.render(React.createElement(
  ApolloProvider,
  { client: client },
  React.createElement(App, null)
), document.getElementById('root'));